import { Divider, Form, FormInstance, Switch } from 'antd'
import { partition } from 'lodash'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { JiraColumnProps } from '@/modules/project/project-detail/project-jql/project-jql-table-config.component'
import { JiraTableColumnType } from '@/schemas'

interface JQLTableConfigProps {
  form: FormInstance<any>
  columns: JiraColumnProps[]
  hasBugField?: boolean
  hasReleaseStatusField?: boolean
}

export const JQLTableConfig: React.FC<JQLTableConfigProps> = ({
  form,
  columns,
  // hasBugField = true,
  // hasReleaseStatusField = true,
}) => {
  const { t } = useTranslation()
  const [jiraColumns] = partition(columns, (col) => col.type === JiraTableColumnType.Jira)
  return (
    <>
      <Form form={form} preserve={false}>
        <Divider>{t('jira fields')}</Divider>
        {jiraColumns.map((col) => {
          return (
            <Form.Item
              labelCol={{ span: 8 }}
              labelAlign='left'
              wrapperCol={{ span: 16, offset: 13 }}
              key={col.key}
              label={t(col.key)}
              name={col.key}
              valuePropName='checked'
            >
              <Switch />
            </Form.Item>
          )
        })}
        {/* <Divider>{t('other fields')}</Divider>
        {otherColumns.map((col) => {
          const isBugField = col.key === 'bugResolved'
          const isReleaseStatusField = col.key === 'releaseStatus'
          return (
            <Form.Item
              labelCol={{ span: 8 }}
              labelAlign='left'
              wrapperCol={{ span: 16, offset: 13 }}
              key={col.key}
              label={t(col.key)}
              name={col.key}
              valuePropName='checked'
            >
              <Switch disabled={(isBugField && !hasBugField) || (isReleaseStatusField && !hasReleaseStatusField)} />
            </Form.Item>
          )
        })} */}
      </Form>
    </>
  )
}
